document.addEventListener('DOMContentLoaded', () => {
  const showAsideBtn = document.querySelector('.js--aside_btn');
  const closeAsideBtn = document.querySelector('.js--aside_close');
  const showAsideBtnMob = document.querySelector('.js--show_aside_mob');
  const main = document.querySelector('.js--main');
  const aside = document.querySelector('.js--aside');
  const showAsideHeader = document.querySelector('.js--show_aside');
  const $body = document.body;
  const $root = document.getElementsByTagName('html')[0];
  const $screen = document.querySelector('.screen');

  const openAside = () => {
    aside.classList.add('showOnSide');
    $body.classList.add('asideIsOpen');
    $root.classList.add('asideIsOpen');
  };

  const closeAside = () => {
    if (aside) {
      aside.classList.remove('showOnSide');
      $body.classList.remove('asideIsOpen');
      $root.classList.remove('asideIsOpen');
    }
  };

  if (showAsideBtnMob) {
    showAsideBtnMob.addEventListener('click', function () {
      openAside();
    })
  }

  $screen.addEventListener('click', closeAside);
  if (closeAsideBtn) {
    closeAsideBtn.addEventListener('click', closeAside);
  }
  if (showAsideBtn) {
    showAsideBtn.addEventListener('click', function () {
      if (showAsideHeader.classList.contains('offset-lg-8')) {
        showAsideHeader.classList.remove('col-lg-4');
        showAsideHeader.classList.remove('offset-lg-8');
        showAsideHeader.classList.add('col-lg-2');
        showAsideHeader.classList.add('offset-lg-10');
      } else {
        showAsideHeader.classList.add('col-lg-4');
        showAsideHeader.classList.add('offset-lg-8');
        showAsideHeader.classList.remove('col-lg-2');
        showAsideHeader.classList.remove('offset-lg-10');
      }
      aside.classList.toggle('show');
      if (main.classList.contains('col-lg-8')) {
        main.classList.remove('col-lg-8');
        aside.classList.remove('col-lg-4');
        main.classList.add('col-lg-12');
      } else if (main.classList.contains('col-lg-12')) {
        main.classList.remove('col-lg-12');
        main.classList.add('col-lg-8');
        aside.classList.add('col-lg-4');
      } else if (main.classList.contains('col-lg-6')) {
        main.classList.remove('col-lg-6');
        aside.classList.remove('col-lg-3');
        main.classList.add('col-lg-9');
      } else if (main.classList.contains('col-lg-9')) {
        main.classList.remove('col-lg-9');
        main.classList.add('col-lg-6');
        aside.classList.add('col-lg-3');
      }
    });

  }

});
